import { useTranslation } from 'react-i18next';
import * as Styled from './GfmLeaderboard.styled';
import { transformLeaderboardData } from './utils';
import LeaderboardItem from './LeaderboardItem';
import { GfmLeaderboardEmptyState } from './GfmLeaderboardEmptyState';
import { Standalone } from '../../containers/Standalone';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The `GfmLeaderboard` standalone block displays a leaderboard of fundraisers for a specific campaign with GFM data.
 */
export const GfmLeaderboard = ({
  siteBaseUrl,
  campaignId,
  data,
  preview = false,
  shouldRender = true,
  campaignLocale
}) => {
  const {
    t
  } = useTranslation('blocks.gfmLeaderboard');
  if (!shouldRender) {
    return null;
  }
  const collection = data?.data?.campaignById?.collection || null;
  const entries = collection ? transformLeaderboardData(collection.fundraisersPaginated.edges) : [];
  const count = collection?.size ?? 0;
  const countDisplayString = new Intl.NumberFormat(campaignLocale ?? 'en-US').format(count);
  const shouldShowEmptyState = preview === true || !collection || entries.length === 0;

  // Render the empty state if in preview mode, no collection is found, or there are no entries
  if (shouldShowEmptyState) {
    return /*#__PURE__*/_jsx(Standalone, {
      "data-id": "lp-gfm-leaderboard-empty-state",
      children: /*#__PURE__*/_jsx(Styled.Container, {
        children: /*#__PURE__*/_jsx(Styled.ContentArea, {
          children: /*#__PURE__*/_jsx(GfmLeaderboardEmptyState, {
            siteBaseUrl: siteBaseUrl,
            campaignId: campaignId
          })
        })
      })
    });
  }

  // Happy path: render the leaderboard with entries
  return /*#__PURE__*/_jsx(Standalone, {
    "data-id": "lp-gfm-leaderboard",
    children: /*#__PURE__*/_jsxs(Styled.Container, {
      children: [/*#__PURE__*/_jsxs(Styled.Header, {
        children: [/*#__PURE__*/_jsx(Styled.Title, {
          children: t('GfmLeaderboard.title', 'Leaderboard')
        }), /*#__PURE__*/_jsx(Styled.CountBadge, {
          children: countDisplayString
        })]
      }), /*#__PURE__*/_jsx(Styled.ContentArea, {
        children: /*#__PURE__*/_jsx(Styled.ItemsList, {
          children: entries.map(entry => /*#__PURE__*/_jsx(LeaderboardItem, {
            entry: entry,
            campaignLocale: campaignLocale,
            siteBaseUrl: siteBaseUrl
          }, entry.id))
        })
      })]
    })
  });
};